module.exports = __webpack_public_path__ + "img/settings.81c76599.png";